var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgLockDark = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 8,
    height: 10,
    viewBox: "0 0 8 10",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "lock",
    transform: "translate(-5.625 -1.125)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1535",
    "data-name": "Path 1535",
    d: "M12.17,5.964H7.08a.69.69,0,0,0-.727.645V9.835a.69.69,0,0,0,.727.645H12.17a.69.69,0,0,0,.727-.645V6.609A.69.69,0,0,0,12.17,5.964ZM7.08,5.319a1.38,1.38,0,0,0-1.455,1.29V9.835a1.38,1.38,0,0,0,1.455,1.29H12.17a1.38,1.38,0,0,0,1.455-1.29V6.609a1.38,1.38,0,0,0-1.455-1.29Zm0-1.935A2.415,2.415,0,0,1,9.625,1.125,2.415,2.415,0,0,1,12.17,3.383V5.319h-.727V3.383A1.725,1.725,0,0,0,9.625,1.77,1.725,1.725,0,0,0,7.807,3.383V5.319H7.08Z",
    transform: "translate(0 0)",
    fill: "#999",
    fillRule: "evenodd"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLockDark);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/LockDark.fb5b4389961bdeea48126a6ab4b6829e.svg";